/* eslint-disable max-len */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom';

import Invitation from 'auth/Invitation';
import InvitationExpired from 'auth/InvitationExpired';
import Login from 'auth/Login';
import PasswordReset from 'auth/PasswordReset';
import PasswordSet from 'auth/PasswordSet';
import { ErrorBoundary } from 'components/errorBoundaries';
import Launchpad from 'components/Launchpad';
import ScrollToTop from 'components/ScrollToTop';
import AuthContextProviders from 'contexts/AuthContextProviders';
import OnboardingRegister from 'onboarding/OnboardingRegister';
import PlatformIntegration from 'onboarding/PlatformIntegration';
import PlatformIntegrationCompleted from 'onboarding/PlatformIntegrationCompleted';
import ShoptetPlatformIntegrationEmail from 'onboarding/shoptet/ShoptetPlatformIntegrationEmail';
import { PublicApiProvider } from 'public-api';
import authRoutes from 'routes/codegen/authRoutes';
import { ToastContainer } from 'ui';
import AuthShell from 'ui-brand/components/AuthShell';

class Retino extends React.Component {
  componentDidCatch(error, errorInfo) {
    window.Sentry.captureException(error, { extra: errorInfo });
  }

  render() {
    return (
      <ErrorBoundary>
        <AuthContextProviders>
          <ScrollToTop />
          <Routes>
            <Route
              element={
                <AuthShell>
                  <Outlet />
                </AuthShell>
              }
            >
              <Route
                element={
                  <PublicApiProvider showErrorToasts={false}>
                    <Outlet />
                  </PublicApiProvider>
                }
              >
                <Route path={authRoutes.onboarding.url} element={<OnboardingRegister />} />
                <Route path={authRoutes.onboardingPlatformIntegrationPlatformIntegrationDetail.url} element={<PlatformIntegration />} />
              </Route>
              <Route path={authRoutes.authLogin.url} element={<Login />} />
              <Route path={authRoutes.authPasswordReset.url} element={<PasswordReset />} />
              <Route path={authRoutes.authResetUidb64Token.url} element={<PasswordSet />} />

              <Route path={authRoutes.onboardingShoptetDisplayEmailPlatformIntegrationDetail.url} element={<ShoptetPlatformIntegrationEmail />} />
              <Route path={authRoutes.onboardingPlatformIntegrationPlatformIntegrationIdCompleted.url} element={<PlatformIntegrationCompleted />} />
              <Route path={authRoutes.companyInvitationExpired.url} element={<InvitationExpired />} />
              <Route path={authRoutes.companyInvitationAcceptInvitationDetail.url} element={<Invitation />} />
            </Route>
            <Route
              path={authRoutes.companyLaunchpad.url}
              element={
                <AuthShell languageSelector={false}>
                  <Launchpad />
                </AuthShell>
              }
            />
          </Routes>

          <ToastContainer />
        </AuthContextProviders>
      </ErrorBoundary>
    );
  }
}

const container = document.getElementById('react-root');
const root = createRoot(container!);
root.render(
  <BrowserRouter>
    <Retino />
  </BrowserRouter>,
);
